// extracted by mini-css-extract-plugin
export default {"Main":"QuickLinks_Main__3DlOG"};